import React from 'react';

// Default value is defined in ClassificationContextProvider
export const ClassificationContext = React.createContext({});
